import axios from "axios";
import { format } from "date-fns";
import moment from "moment";
import { BASE_URL } from "../config/api_collection";
import { MOCK_DATA_MODE } from "../constants/config/config";
import {
  BOOKING_TYPE,
  PRODUCT_CLASSES,
  PASSENGER_TYPE,
  CONVENIENCE_FEE_CODE,
  ERROR_API_NAME,
  FARE_TYPES
} from "../constants/variables";
import { AirportDetails, BookingJourney, BookingJourneyLayoverDetails, Leg } from "../global";
import apolloClient from "../graphql";
import { GET_AVAILABILITY_SEARCH } from "../graphql/queries";
import { currencyConverter } from "../helper/currencyConverter";
import { getCityNameByAirport } from "../helper/getCityNameByAirport/getCityNameByAirport";
import { flightListOfOneway } from "../mock/availabilityv4";
import { errorHandingErrorMessage } from "../services/errrorHandling/errorHandling";
import { getPassengerType } from "../services/passengers";
import { fetchCMSConfig } from "./cms";
import { getHeaderData } from "./crm";
import { fecthData } from "./lowFares";
import { calculateJourneyDuration, calculateLegLayoverDuration, getDurationString } from "helper/duration";

const GET_ACTIVE_AIRPORT_LIST = `${BASE_URL}/api/nsk/v2/resources/markets?ActiveOnly=true`

const getPassengerTypePrice = (brandFareData, passenger) => {
  try {
    let passengerTypeFare = [];
    for (let index = 0; index < brandFareData.length; index++) {
      const passengerFares = brandFareData[index]?.passengerFares;
      const element = brandFareData[index];
      for (let i = 0; i < passengerFares.length; i++) {
        const temp = passengerFares[i].serviceCharges;
        let passengerCount = 1;
        if (
          passengerFares[i]?.passengerType == PASSENGER_TYPE.ADULT ||
          passengerFares[i]?.passengerType == PASSENGER_TYPE.MEDICAL ||
          passengerFares[i]?.passengerType == PASSENGER_TYPE.ARMED_FORCE
        ) {
          passengerCount = passenger.adult;
        }
        if (passengerFares[i]?.passengerType == PASSENGER_TYPE.SENIOR_CITIZEN) {
          passengerCount = passenger.seniorcitizen;
        }
        if (passengerFares[i]?.passengerType == PASSENGER_TYPE.CHILD) {
          passengerCount = passenger.child;
        }

        for (let j = 0; j < temp.length; j++) {
          if (!(temp[j].code == null && temp[j].detail == null)) {
            // passenger fare
            // temp[j]['amount'] = ( temp[j]['amount']) * passengerCount; // each passenger will be added
            temp[j].passengerCount = passengerCount;
          }
        }
        if (typeof passengerTypeFare === "undefined") {
          passengerTypeFare = [];
        }
        if (passengerTypeFare[passengerFares[i]?.passengerType]) {
          passengerTypeFare[passengerFares[i]?.passengerType]["discountedFare"] += passengerFares[i].discountedFare;
          passengerTypeFare[passengerFares[i]?.passengerType]["publishedFare"] += passengerFares[i].publishedFare;
          passengerTypeFare[passengerFares[i]?.passengerType]["revenueFare"] += passengerFares[i].revenueFare;
          passengerTypeFare[passengerFares[i]?.passengerType]["amount"] += passengerFares[i].serviceCharges
            .filter((code) => code.type != "PromotionDiscount")
            .reduce((accumulator, current) => accumulator + current.amount, 0);
          passengerTypeFare[passengerFares[i]?.passengerType]["tax"].concat(temp);
          passengerTypeFare[passengerFares[i]?.passengerType]["tax"].flat(2);
          passengerTypeFare[passengerFares[i]?.passengerType]["totalTax"] += passengerFares[i].serviceCharges
            .filter((code) => code.detail != null && code.type !== "PromotionDiscount")
            .reduce((accumulator, current) => accumulator + current.amount, 0);
        } else {
          passengerTypeFare[passengerFares[i]?.passengerType] = {
            discountedFare: passengerFares[i].discountedFare,
            publishedFare: passengerFares[i].publishedFare,
            revenueFare: passengerFares[i].revenueFare,
            amount: passengerFares[i].serviceCharges
              .filter((code) => code.type !== "PromotionDiscount")
              .reduce((accumulator, current) => accumulator + current.amount, 0),
            tax: temp,
            totalTax: passengerFares[i].serviceCharges
              .filter((code) => code.detail != null && code.type !== "PromotionDiscount")
              .reduce((accumulator, current) => accumulator + current.amount, 0)
          };
        }

        const serviceArray = passengerFares[i].serviceCharges;
        let taxAmount = 0;
        for (let ind = 0; ind < serviceArray.length; ind++) {
          const currentTax = serviceArray[ind];

          if (currentTax.detail != null && currentTax.type === "PromotionDiscount") {
            // todo : need to remove this hardcoding
            taxAmount -= currentTax.amount;
          } else {
            taxAmount += currentTax.amount;
          }
        }
        passengerTypeFare[passengerFares[i]?.passengerType].amount = taxAmount;
        passengerTypeFare[passengerFares[i]?.passengerType].count = passengerCount;
      }
    }

    return passengerTypeFare;
  } catch (error) {
    console.warn(error);
  }
};
const removeCertainTax = (passengerFares) => {
  let subtractAmount = 0;
  for (let ind = 0; ind < passengerFares.length; ind++) {
    const tempServiceChargesPrice = passengerFares[ind]?.serviceCharges;
    const taxData = tempServiceChargesPrice.find((taxPrice) => taxPrice.code == CONVENIENCE_FEE_CODE);
    if (taxData) {
      subtractAmount = taxData?.amount;
    }
  }
  return subtractAmount;
};
const removeCertainTaxForPaxType = (passengerType, passenger) => {
  let subtractAmount = 0;
  let overall = 0;
  let passengerCount = 1;
  Object.keys(passengerType).map((key, index) => {
    // check for pax type and set the value
    if (key === PASSENGER_TYPE.ADULT || key === PASSENGER_TYPE.MEDICAL || key === PASSENGER_TYPE.ARMED_FORCE) {
      passengerCount = passenger.adult
    }
    if (key === PASSENGER_TYPE.SENIOR_CITIZEN) {
      passengerCount = passenger.seniorcitizen;
    }
    if (key === PASSENGER_TYPE.CHILD) {
      passengerCount = passenger.child;
    }
    // for tax : remove the cFee and in
    const taxData = passengerType[key]?.tax.find(
      (taxPrice) => taxPrice.code === CONVENIENCE_FEE_CODE || taxPrice.type === "IncludedTax"
    );
    if (index === 0) {
      if (taxData) {
        subtractAmount += taxData?.amount; // subtract amount for flight search page
      }
    }

    overall += taxData?.amount * passengerCount; // subtract amount for flight search page
  });
  return { singlePax: subtractAmount, overall };
};

// function to extract fares from Fare availibility key it extracts all the saver,premium and luxe fares that needs to displayed in flight listing page.
const getFares = (tripFares: any, availabilityFares: any, passenger: any) => {
  const fareBrands = PRODUCT_CLASSES;
  let faresWithBrands = [];
  const combinedFares = [];
  const checkProductClass = [];
  tripFares.map((tripFare) => {
    if (availabilityFares && availabilityFares.length > 0) {
      availabilityFares.map((fareavailable) => {
        if (fareavailable.key.includes(tripFare.fareAvailabilityKey)) {
          combinedFares.push({ ...tripFare, ...fareavailable.value });
        }
      });
    }
  });
  /*
  combinedFares is an array, which hold tripfare and fareavailable base on the key ;
  only for one journey 
  */
  if (combinedFares && combinedFares.length > 0) {
    combinedFares.map((combinedFare) => {
      combinedFare.fares.map((pc) => {
        if (!checkProductClass.includes(pc.productClass)) {
          checkProductClass.push(pc.productClass);

          const passengerPrice = getPassengerTypePrice(combinedFare.fares, passenger);
          const subtractAmount = removeCertainTax(pc.passengerFares); // for wef, we need to skip that tax
          if (pc.productClass != null) {
            fareBrands.map((fareBrand) => {
              if (fareBrand === pc.productClass) {
                const passengerPrice = getPassengerTypePrice(combinedFare.fares, passenger);
                faresWithBrands.push({
                  ...pc,
                  ...combinedFare.totals,
                  fareAvailabilityKey: combinedFare.fareAvailabilityKey,
                  passengerPrice,
                  subtractAmount
                });
              } else {
                return null;
              }
            });
          } else {
            faresWithBrands.push({
              ...pc,
              ...combinedFare.totals,
              fareAvailabilityKey: combinedFare.fareAvailabilityKey,
              passengerPrice,
              subtractAmount
            });
          }
        }
      });
    });

    faresWithBrands = faresWithBrands.sort((a, b) => {
      if (a.productClass === "EC") return -1;
      if (b.productClass === "EC") return 1;
      return 0;
    });

    return faresWithBrands;
  }
  return null;
};

const getSoldOutStatus = async (origin: string, destination: string, date: Date, selectedCurrency: string) => {
  try {
    const lowFareAPIResponse = await fecthData(origin, destination, date, selectedCurrency);

    const checkIfSoldOut = lowFareAPIResponse?.data?.availabilityLowFareEstimate?.lowFares?.find(
      (flightData: any) => format(new Date(date), "yyyy/MM/dd") === format(new Date(flightData.date), "yyyy/MM/dd")
    );

    return checkIfSoldOut?.soldOut ?? false;
  } catch (error) {
    console.warn(error);
    return null;
  }
};
// main function that needs to be passed to the components of flight listing component. it consists of all the data that needs to displayed.
export async function getListOfFlight(
  origin: string,
  destination: string,
  date: any,
  passenger: any,
  tripType: any,
  returnDate: any,
  promoCode: any,
  selectedSpecialFare: any = {},
  selectedCurrency: string,
  selectedCurrencyDetails: any = {},
  nationality: string,
) {
  let filteredArrayOfData = [];
  const orgDest = `${origin}|${destination}`;
  const destOrg = `${destination}|${origin}`;
  const convertDate = moment(date).format("YYYY-MM-DD");
  const conv_ReturnDate = moment(returnDate).format("YYYY-MM-DD");
  const {
    journeyAvailableKey,
    flightNumbers,
    saverfares,
    departureTerminal,
    arrivalTerminalConnecting,
    departureTerminalConnecting,
    arrivalTerminal,
    journeyKey,
    fareAvailabilityKey,
    premiumFare,
    totalFares,
    displayFare,
    luxeFare
  }: any = "";
  // api call
  const flightData = await fetchData(
    origin,
    destination,
    convertDate,
    passenger,
    tripType,
    conv_ReturnDate,
    promoCode,
    selectedSpecialFare,
    selectedCurrency,
    selectedCurrencyDetails,
    nationality
  );
  filteredArrayOfData = await getListOfFlightArray(
    flightData,
    orgDest,
    destOrg,
    journeyAvailableKey,
    journeyKey,
    fareAvailabilityKey,
    totalFares,
    displayFare,
    flightNumbers,
    departureTerminal,
    arrivalTerminalConnecting,
    departureTerminalConnecting,
    arrivalTerminal,
    saverfares,
    premiumFare,
    luxeFare,
    tripType,
    passenger,
    selectedCurrency,
    selectedCurrencyDetails
  );
  if (tripType === BOOKING_TYPE.ROUND_TRIP && filteredArrayOfData?.length < 2) {
    const originInResponse = filteredArrayOfData?.[0]?.[0]?.originStation;
    const destinationInResponse = filteredArrayOfData?.[0]?.[0]?.destinationStation;

    if (originInResponse === origin && destinationInResponse === destination) {
      filteredArrayOfData?.push([]);
    } else if (originInResponse === destination && destinationInResponse === origin) {
      filteredArrayOfData?.unshift([]);
    }
  }

  const soldOutStatus = [];

  if (filteredArrayOfData.length < 2) {
    const onwardSoldOutStatus = await getSoldOutStatus(origin, destination, date, selectedCurrency);
    soldOutStatus.push(onwardSoldOutStatus);
  } else {
    const onwardSoldOutStatus = await getSoldOutStatus(origin, destination, date, selectedCurrency);
    const returnSoldOutStatus = await getSoldOutStatus(destination, origin, date, selectedCurrency);
    soldOutStatus.push(onwardSoldOutStatus);
    soldOutStatus.push(returnSoldOutStatus);
  }

  return { data: filteredArrayOfData, soldOut: soldOutStatus };
}

export async function fetchData(
  origin: string,
  destination: string,
  date: any,
  passenger: any,
  tripType: any,
  returnDate: any,
  promoCode: string,
  selectedSpecialFare: any = {},
  selectedCurrency: string,
  selectedCurrencyDetails: any = {},
  nationality: string,
) {
  // for passenger count
  try {
    let passengerCount: any = [];
    let listOfFlight = {};
    if (passenger?.adult) {
      passengerCount = [...passengerCount, { count: passenger?.adult, type: "ADT" }];
    }
    if (passenger?.extraSeat) {
      passengerCount = [...passengerCount, { count: passenger?.extraSeat, type: "EXST" }];
    }
    if (passenger?.seniorcitizen) {
      passengerCount = [...passengerCount, { count: passenger?.seniorcitizen, type: "SNR" }];
    }
    if (passenger?.child) {
      passengerCount = [...passengerCount, { count: passenger?.child, type: "CHD" }];
    }

    passengerCount = await getPassengerType(passenger, selectedSpecialFare);

    // senior citi, child

    if (MOCK_DATA_MODE) {
      listOfFlight = flightListOfOneway;
    } else if (tripType === "oneWay" || tripType === BOOKING_TYPE.ONE_WAY) {
      listOfFlight = await apolloClient.query({
        query: GET_AVAILABILITY_SEARCH,
        variables: {
          request: {
            criteria: [
              {
                stations: {
                  originStationCodes: [origin],
                  destinationStationCodes: [destination]
                },
                dates: {
                  beginDate: date
                },
                filters: {
                  compressionType: "CompressByProductClass",
                  maxConnections: 4,
                  productClasses: PRODUCT_CLASSES,
                  fareTypes: FARE_TYPES
                }
              }
            ],
            passengers: {
              types: passengerCount,
              residentCountry: nationality
            },
            codes: {
              currencyCode: selectedCurrency,
              promotionCode: promoCode
            },
            numberOfFaresPerJourney: 10, // limit the fare count
            taxesAndFees: "Taxes"
          }
        },
        fetchPolicy: "no-cache"
      });
    } else if (tripType === BOOKING_TYPE.ROUND_TRIP) {
      listOfFlight = await apolloClient.query({
        query: GET_AVAILABILITY_SEARCH,
        variables: {
          request: {
            criteria: [
              {
                stations: {
                  originStationCodes: [origin],
                  destinationStationCodes: [destination]
                },
                dates: {
                  beginDate: date,
                  endDate: date
                },
                filters: {
                  compressionType: "CompressByProductClass",
                  maxConnections: 4,
                  productClasses: PRODUCT_CLASSES,
                  fareTypes: FARE_TYPES
                }
              },
              {
                stations: {
                  originStationCodes: [destination],
                  destinationStationCodes: [origin]
                },
                dates: {
                  beginDate: returnDate,
                  endDate: returnDate
                },
                filters: {
                  compressionType: "CompressByProductClass",
                  maxConnections: 4,
                  productClasses: PRODUCT_CLASSES,
                  fareTypes: FARE_TYPES
                }
              }
            ],
            passengers: {
              types: passengerCount,
              residentCountry: nationality
            },
            codes: {
              currencyCode: selectedCurrency,
              promotionCode: promoCode
            },
            numberOfFaresPerJourney: 10, // limit the fare as 10
            taxesAndFees: "Taxes"
          }
        },
        fetchPolicy: "no-cache"
      });
    }
    return listOfFlight;
  } catch (err) {
    return errorHandingErrorMessage(ERROR_API_NAME.FLIGHT_AVALIABLE, err);
  }
}

export function getLowestFare(extractedFares, departureTime) {
  if (extractedFares && extractedFares.length > 0) {
    const lowFare = extractedFares.reduce((a, b) => Math.min(a, b));
    return lowFare;
  }
}

function getComparedFare(extractedFares) {
  const fares = extractedFares.map((fare) => fare?.fareTotal);
  return fares;
}

export async function getListOfFlightArray(
  flightData,
  orgDest,
  destOrg,
  journeyAvailableKey,
  journeyKey,
  fareAvailabilityKey,
  totalFares,
  displayFare,
  flightNumbers,
  departureTerminal,
  arrivalTerminalConnecting,
  departureTerminalConnecting,
  arrivalTerminal,
  saverfares,
  premiumFare,
  luxeFare,
  tripType,
  passenger,
  selectedCurrency,
  selectedCurrencyDetails
) {
  const listofTotalFares = [];
  const filteredArrayofData = [];
  let fares;
  const res = await fetchCMSConfig();
  const configData = res?.data?.story?.content?.config[0];
  const allowedEquipments = configData.supportedEquipmentTypes;

  if (flightData?.data?.availabilityv4.results.length && flightData?.data.availabilityv4.results.length > 0) {
    flightData.data.availabilityv4.results.map((trips, journeyIndexKey) => {
      // trip is an array, which contain one journey
      const newJourneyFlights = []; // contain trip from origin to destination
      if (trips.trips && trips.trips.length > 0) {
        trips.trips.map(
          (journey) => {
            journey?.journeysAvailableByMarket.map((journeyAvailable) => {
              journeyAvailableKey = journeyAvailable.key; // setting ori|dest text

              journeyAvailable?.value.map((cardData) => {
                journeyKey = cardData.journeyKey;
                let subtractAmount = {};
                let allowedFlight = true;
                const allowed = cardData.segments.map((cardInfo) => {
                  cardInfo?.legs?.map((leg) => {
                    if (allowedEquipments.indexOf(leg.legInfo.equipmentType) < 0) {
                      allowedFlight = false;
                    }
                  });
                  return allowedFlight;
                });

                if (!allowedFlight) {
                  return false;
                }

                fareAvailabilityKey = cardData.fares?.[0]?.fareAvailabilityKey; // wrong only take ec when set to zero
                fares = cardData.fares; // contain both the fare type ( ec, av )
                const extractedFares = getFares(
                  cardData.fares,
                  flightData.data.availabilityv4.faresAvailable,
                  passenger
                );
                totalFares = extractedFares;
                const passengerFare = [];
                let totalDisplayFare: any;
                extractedFares.map((ec) => {
                  // need to check why only for ec is been writen
                  // subtractAmount =   // for wef, we need to skip that tax

                  subtractAmount = removeCertainTaxForPaxType(ec.passengerPrice, passenger);
                  passengerFare.push(ec.passengerPrice); // passengerFare, need to add the skip tax type
                  if (ec.productClass == "EC" || ec.productClass == null) {
                    const discountedDisplayFare = currencyConverter(ec.discountedTotal, selectedCurrency, selectedCurrencyDetails);
                    totalDisplayFare = currencyConverter(ec.fareTotal, selectedCurrency, selectedCurrencyDetails);
                    // for extracting lowfare
                    listofTotalFares.push(ec.fareTotal);
                    return (displayFare = {
                      discountedDisplayFare,
                      totalDisplayFare,
                      displayFareValue: ec.fareTotal
                    });
                  }
                  return null;
                });
                let Noofstops = [];
                let allStops = [];
                flightNumbers = [];
                let isThroughFlight = false;
                cardData.segments.map((cardInfo) => {
                  const flightNumber = cardInfo.identifier.carrierCode + cardInfo.identifier.identifier;
                  flightNumbers.push(flightNumber);
                  
                  const Noofstop = cardInfo?.legs?.map((stop) => stop?.designator?.destination);
                  if (cardInfo?.legs.length > 1) {
                    isThroughFlight = true;
                    for (let tempind = 1; tempind < cardInfo?.legs.length; tempind++) {
                      flightNumbers.push(flightNumber);
                    }
                  }
                  // allStops.push(allStops);
                  // allStops.concat(allStops)
                  // Noofstops.push(Noofstop);
                  Noofstops = Noofstops.concat(Noofstop);
                });

                departureTerminal = cardData?.segments?.[0]?.legs?.[0]?.legInfo?.departureTerminal;
                arrivalTerminalConnecting = cardData?.segments?.[0]?.legs?.[0]?.legInfo?.arrivalTerminal;
                const lastSegment = cardData?.segments?.[cardData?.segments?.length - 1]
                departureTerminalConnecting = lastSegment?.legs?.[lastSegment?.legs?.length - 1].legInfo?.departureTerminal;
                arrivalTerminal = lastSegment?.legs?.[lastSegment?.legs?.length - 1].legInfo?.arrivalTerminal;

                const tempStops = cardData.segments.map((cardInfo) =>
                  cardInfo?.legs?.map((stop) => stop?.designator?.destination)
                );
                allStops = allStops.concat(tempStops);
                const arrivalTime = moment(cardData.designator.arrival).format("HH:mm");
                const departureTime = moment(cardData.designator.departure).format("HH:mm");
                const arrivalDateAndTime = cardData.designator.arrival;
                const departureDateAndTime = cardData.designator.departure;
                const originStation = cardData.designator.origin;
                const destinationStation = cardData.designator.destination;

                const journeyDuration = calculateJourneyDuration(cardData);
                const duration = getDurationString(journeyDuration);
                const durationInMin = journeyDuration.asMinutes();

                // fare for single passenger :
                const passengerFares = cardData.fares?.[0]?.passengerFares;
                const passengerTypeFareValue = [];
                const { flightType } = cardData;
                // to display lowest fare indicator
                const lowestFare = getLowestFare(listofTotalFares, departureTime);
                const comparedFare = getComparedFare(extractedFares);
                Noofstops.pop();
                allStops.pop();
                newJourneyFlights.push({
                  journeyAvailableKey,
                  arrivalTime,
                  departureTime,
                  originStation,
                  destinationStation,
                  flightNumbers,
                  Noofstops,
                  saverfares,
                  premiumFare,
                  luxeFare,
                  totalFares,
                  displayFare,
                  duration,
                  durationInMin,
                  journeyKey,
                  fareAvailabilityKey,
                  departureTerminal,
                  arrivalTerminal,
                  arrivalTerminalConnecting,
                  departureTerminalConnecting,
                  passengerTypeFareValue,
                  passengerFare,
                  lowestFare,
                  comparedFare,
                  subtractAmount,
                  journeyIndexKey,
                  arrivalDateAndTime,
                  departureDateAndTime,
                  allStops,
                  flightType,
                  isThroughFlight
                });
              });
            });
          } // end of one journey :
        );
      }
      filteredArrayofData.push(newJourneyFlights);
    });

    // if(tripType == BOOKING_TYPE.ONE_WAY){
    //   const onWardJourney = tripData.filter(arr => arr.journeyAvailableKey === orgDest);
    //   filteredArrayofData.push({value: onWardJourney})
    // }else{
    //   const onWardJourney = tripData.filter(arr => arr.journeyAvailableKey === orgDest);
    //   filteredArrayofData.push({value: onWardJourney});
    //   const returnJourney = tripData.filter(arr => arr.journeyAvailableKey === destOrg);
    //   filteredArrayofData.push({value: returnJourney})
    // }
    return filteredArrayofData;
  }
  return [];
}

export async function getActiveAirport() {
  try {
    const headers = getHeaderData();
    const response = await axios.get(GET_ACTIVE_AIRPORT_LIST, { headers });
    return response?.data?.data;
  } catch (error: any) {
    console.warn("Failed to airport list", error.message);
    return error?.response;
  }
}

export function getLayoverDurationCity(journeyDetails: BookingJourney, airports: AirportDetails[]) {
  try {
    const layoverDetails: BookingJourneyLayoverDetails[] = [];
    let previousLeg: Leg | null = null;

    if (journeyDetails?.segments?.length > 1) {
      journeyDetails?.segments?.forEach((segment) => {
        segment?.legs?.forEach((leg) => {
          if (previousLeg) {
            const legDetail = {
              cityName: getCityNameByAirport(leg?.designator?.origin, airports),
              duration: getDurationString(calculateLegLayoverDuration(previousLeg, leg))
            };
            layoverDetails.push(legDetail);
          }
          previousLeg = leg;
        });
      });

      return { ...journeyDetails, layoverDetails };
    }

    return journeyDetails || {};
  } catch (err) {
    console.warn("Error in getting layover duration and cityname:", err);
    return journeyDetails || {};
  }
}
